module.exports = __webpack_public_path__ + "static/img/shanyao.b9a25bc5.png";